export default {
  Quote: 0,
  RequestInspection: 1,
  TotalLoss: 2
}
